export default __webpack_public_path__ + "static/media/3.160953a9.jpeg";